module.exports = __webpack_public_path__ + "img/top-title.0fb48cce.png";